interface LoginMessagesProps {
  error: string;
  success: string;
}

/**
 * Form-level error and success messages for the login page. They sit above
 * every sign-in path, so a message from any of them is seen without scrolling.
 */
export const LoginMessages = ({ error, success }: LoginMessagesProps) => (
  <>
    {error && (
      <div role="alert" className="p-3 mb-4 bg-red-50 border border-red-200 rounded-md">
        <p className="text-sm text-red-600">{error}</p>
      </div>
    )}
    {success && (
      <div role="status" className="p-3 mb-4 bg-green-50 border border-green-200 rounded-md">
        <p className="text-sm text-green-600">{success}</p>
      </div>
    )}
  </>
);
